export default {
  '95%-of-cases': '95% dokončených<br>případů je<br>vyplácena náhrada.',
  'add-passenger': 'Přidat cestovatele',
  'agreement-for': 'Dohoda pro {name}',
  back: 'Zpět',
  birthdate: 'Datum narození',
  'check-if-you-are-entitled': 'Zkontrolujte, zda máte nárok<br>na odškodnění',
  'check-your-compensation': 'Kontrola kompenzace',
  congratulations: 'Blahopřejeme!',
  'choose-date': 'Vyberte datum',
  'choose-date-from': 'Vyberte datum',
  'choose-date-to': 'Vyberte datum',
  'choose-from-the-list': 'Vyberte ze seznamu',
  'choose-option': 'Vyberte',
  clear: 'Jasné',
  'congratulations-you-entitled':
    'Gratulujeme, můžete získat až {compensation} EUR v odškodnění!',
  'contact-data': 'osobní údaje',
  continue: 'Pokračovat',
  'co-passenger': 'Chlapík',
  'delete-passenger': 'Vymažte cestujícího',
  'departure-date': 'Datum odjezdu',
  'departed-from': 'Začátek trasy',
  'dont-have-pesel': 'Nemám číslo PESEL',
  'e-mail-address': 'E-mailová adresa',
  'enter-your-pesel':
    'Zadejte číslo vašeho PESEL a zašlete podpis potvrzující smlouvu o převodu pohledávek pro případ číslo {number}',
  'final-destination': 'Konec trasy',
  finalization: 'Dokončete',
  'find-us-on': 'Najděte<br>nás na adrese:',
  'flight-details': 'Podrobnosti letu',
  'flight-information': 'Informace o letu',
  'flight-verification': 'Ověření letu',
  finalize: 'Finalizuj!',
  finish: 'Dokončit',
  'first-last-name': 'Jméno a příjmení',
  'get-acquainted-with': 'Přečtěte si model smlouvy',
  here: 'zde',
  hours: 'Hodin',
  'how-did-you-find-us': 'Jak jste nás našli?',
  'how-long-was-your-delay': 'Kolik bylo vaše zpoždění v cílovém přístavu?',
  'i-accept-the-conditions': 'Souhlasím s předpisy - k dispozici',
  'i-accept-the-privacy-policy':
    'Souhlasím s politikou ochrany osobních údajů - je k dispozici',
  'i-did-not-reach-the-destination': 'Cestující se tam nedostal',
  'i-hereby-confirm':
    'I, {name}, Tímto potvrzuji uzavření dohody s převodem Passenger Rights sp. z o.o. se sídlem ve Varšavě s číslem {number}.',
  'in-order-to-complete':
    'Chcete-li splnit formality, zadejte prosím své číslo PESEL a podepište jej kurzorem nebo prstem na obrazovce',
  'intermediate-airport-only-connecting-flights':
    'Intermediate letiště (pouze v případě změny)',
  'invite-co-passengers': 'Vyzvěte spolucestující<br>aby získali odškodnění',
  'legal-guardian': 'Právní zástupce',
  'make-an-electric-signature':
    'Vytvořte elektronický podpis pro {name} {surname}',
  minor: 'Nezletilá osoba',
  minutes: 'Minuty',
  'name-of-the-airline': 'Název letecké společnosti',
  'no-results': 'Žádné výsledky',
  none: 'Nedostatek',
  'number-interrupted-flight': 'Číslo letu',
  passenger: 'Cestování: {name}',
  'passengers-support': 'Oddělení<br>Podpory<br>Pasažérů',
  'pesel-number': 'Číslo PESEL',
  'phone-number': 'Kontaktní telefon',
  'privacy-policy': 'Ochrana osobních údajů',
  project: 'Projektu',
  'read-about-us': 'Píše o nás:',
  'ready-accept-the-conditions':
    'Připraven!<br>Přijmout podmínky a<br>dokončit podání žádosti',
  regulations: 'Pravidla',
  'report-another-case': 'Nahlásit jiný případ',
  'remember-passengers-know':
    'Pamatujte si, měli byste poradit cestující o&nbsp;jejich právech!',
  reset: 'Obnovit',
  'select-the-source': 'Vyberte zdroj informací',
  sign: 'Znamení',
  'signature-of-the-traveler': 'Cestovní podpis',
  'start-typing-to-search-airport': 'Začněte psát a Najděte si letiště',
  'start-typing-to-search-airline':
    'Začněte psát a vyhledejte leteckou společnost',
  'thank-you-for-your-thrust':
    'Děkujeme vám za důvěru<br>Passenger Rights Sp. z o.o',
  'we-will-inform':
    'Budeme vás informovat telefonicky nebo e-mailem o zahájení případu nebo o nutnosti doplnit údaje.',
  'what-happened-with-the-flight': 'Co se stalo s letem?',
  'what-was-the-reason': 'Jaký je důvod pro narušení?',
  'you-are-under': 'Jste pod neustálým<br>dohledem zkušených<br>právníků.',
  'you-have-a-problem': 'Máte nějaký problém? Pomoc!',
  'your-application-has-been-submitted':
    'Vaše žádost byla předložena k ověření naší právní oddělení.',
  'your-contract-is-below': 'Níže je vaše dohoda',
  'your-risk-nothing':
    'Riskujete nic,<br>vyplnit formulář,<br>a my se postaráme o zbytek!',
  'your-route': 'Vaše trasa',
  'error-required': 'Toto pole je povinné',
  'error-to-short-for-compensation':
    'Daný čas je příliš krátký na to, aby byl kompenzován',
  'error-delay-is-required':
    'Doba zpoždění nebo "nedosáhl jsem místo" možnost je vyžadována',
  'error-delay-exclusive':
    'Doba zpoždění a možnost "nedosáhl jsem místa" je vyloučeno',
  'error-dont-qualify': 'Bohužel, daný důvod není způsobilý pro odškodnění',
  'error-intermediate-airport': 'Letiště nesmí být stejné jako počáteční',
  'error-destination-overlap':
    'Konečné letiště nesmí být stejné jako přechodné nebo počáteční',
  'error-invalid-email': 'Nesprávná e-mailová adresa',
  'COMMON.ADD': 'Přidat',
  'SIGN.AGREEMENT.AGREEMENT_FORM.CONSENT':
    'I, {passengerName}, Tímto potvrzuji uzavření dohody s převodem Passenger Rights sp. z o.o. se sídlem ve Varšavě s číslem {caseIdent}.',
  'SIGN.AGREEMENT.AGREEMENT_FORM.CONSENT_UNDERAGE':
    'I, {legalGuardian}, jednající jménem a na účet nezletilého {passengerName}, tímto potvrzuji uzavření dohody s převodem Passenger Rights sp. z o.o. se sídlem ve Varšavě s číslem {caseIdent}.',
  'SIGN.AGREEMENT.AGREEMENT_FORM.LEGAL_GUARDIAN': 'Zákonný zástupce',
  'SIGN.AGREEMENT.AGREEMENT_FORM.LEGAL_GUARDIAN_PLACEHOLDER':
    'jméno zákonného zástupce',
  'SIGN.AGREEMENT.AGREEMENT_FORM.LEGAL_GUARDIAN_SIGNATURE':
    'Podpis zákonného opatrovníka',
  'SIGN.AGREEMENT.AGREEMENT_FORM.NO_PESEL': 'Nemám číslo PESEL',
  'SIGN.AGREEMENT.AGREEMENT_FORM.PESEL_ERROR': 'Nesprávné číslo PESEL',
  'SIGN.AGREEMENT.AGREEMENT_FORM.PESEL_NUMBER': 'Číslo sociálního pojištění',
  'SIGN.AGREEMENT.AGREEMENT_FORM.TITLE':
    'Zadejte číslo sociálního pojištění a podepište podpis potvrzující smlouvu o převodu dluhu na číslo případu',
  'SIGN.AGREEMENT.AGREEMENT_FORM.TRAVLER': 'Cestování',
  'SIGN.AGREEMENT.AGREEMENT_FORM.TRAVLER_SIGNATURE': 'Podpis cestujícího',
  'SIGN.AGREEMENT.AGREEMENT_SETUP.LOADING_CASE': 'Načtení oznámení',
  'SIGN.AGREEMENT.CASE_FORM.ADD_DOCUMENTS_TITLE':
    'Přidejte dokumenty, které potřebujete pro svůj požadavek {passengerName}',
  'SIGN.AGREEMENT.CASE_FORM.TICKET_POPUP':
    'Účastní-li se zúčastnil organizovaného turné, přiložte palubní vstupenku a smlouvu s vaší cestovní kanceláří.',
  'SIGN.AGREEMENT.CASE_FORM.TICKET_SCAN': 'Kontrola lístků',
  'SIGN.AGREEMENT.SIGNED.AGREEMENT_FOR': 'Dohoda pro {passengerName}',
  'SIGN.AGREEMENT.SIGNED.READY_DESCRIPTION':
    'Jsme připraveni začít proces získání odškodnění.\nNíže si můžete stáhnout případové dokumenty.',
  'SIGN.AGREEMENT.SIGNED.TITLE':
    'Děkujeme vám za doplnění dat a potvrzení smlouvy o převodu dluhu.',
  'SIGN.SHARED.CONGRATULATIONS.CASE_NOT_FOUND': 'Nenalezli jsme vaši žádost',
  'SIGN.SHARED.CONGRATULATIONS.CONTACT_US':
    'Pokud si myslíte, že se vám něco pokazilo, neváhejte nás kontaktovat!',
  'SIGN.SHARED.CONGRATULATIONS.NOTIFY':
    'Budeme vás informovat telefonicky nebo e-mailem o zahájení případu nebo o nutnosti doplnit údaje.',
  'SIGN.SHARED.CONGRATULATIONS.VERIFICATION':
    'Vaše žádost byla předložena k ověření naší právní oddělení.',
  'login-title': 'Přihlášení',
  'login-button': 'Přihlásit se',
  login: 'přihlašovací jméno',
  password: 'Heslo',
  'error-login-or-pass': 'Neplatné přihlašovací jméno nebo heslo',
  'add-flight': 'Přidat let',
  filter: 'Filtry',
  'filter-button': 'Hledat',
  'flight-number': 'Číslo letu',
  'flights-list': 'Seznam letů',
  'add-request': 'Přidejte případ',
  'how-long-was-delay': 'Jak dlouho bylo zpoždění letu?',
  'planned-arrival': 'Plánovaný čas příjezdu',
  'actual-arrival': 'Reálný čas příjezdu',
  'save-flight': 'Ušetřit let',
  'add-new-request': 'Přidejte případ',
  'departure-airport': 'Odletové letiště',
  'destination-airport': 'Cílové letiště',
  'prefferred-date-of-first-contact': 'Preferované datum kontaktu',
  comments: 'Komentáře',
  'add-comments': 'Přidat komentáře',
  'add-first-name': 'Jméno',
  'add-last-name': 'Příjmení',
  'add-e-mail-address': 'Emailová adresa',
  'add-description': 'Zadejte další popis',
  deadline: 'Uzávěrka',
  'potential-cases': 'Potenciální případy',
  'add-potential-cases': 'Přidejte počet potenciálních případů',
  'amount-for-customer-czg': 'Kwota dla Klienta CZG (PLN)/Z',
  'amount-for-customer-czd-pre-stage':
    'Kwota dla Klienta CZD etap przedsądowy (PLN)/Z',
  'amount-for-customer-czd-main-stage':
    'Kwota dla Klienta CZD etap sądowy (PLN)/Z',
  'upload-rodo-agreement-file': 'Plik ze zdjeciem zgody RODO',
  'i-agree-data-processing-offer':
    'Passenger Rights S.A. (właściciel marki DELAYFIX) z siedzibą w Warszawie informuje, że przetwarza Państwa dane osobowe w postaci Imienia i nazwiska, adresu e-mail oraz numeru telefonu w celu przedstawienia oferty usługi zawarcia umowy przelewu wierzytelności. Pełna klauzula informacyjna dotycząca przetwarzania danych, znajduje się na stronie internetowej',
  'i-agree-data-processing-complaint':
    'Wyrażam zgodę na przetwarzanie moich danych osobowych przez Passenger Rights S.A. z siedzibą w Warszawie (Al. Ujazdowskie 22/5, 00-478 Warszawa) w celu przedstawienia oferty usługi i dochodzenia rekompensaty od przewoźnika lotniczego, na podstawie Rozporządzenia (WE) 261/2004.',
  'add-amount': 'Přidat částku',
  'save-and-leave': 'Uložit a zavřít',
  'save-and-add-new': 'Uložit a přidat dalšíy',
  'error-both-required': 'Jsou požadována obě pole',
  footer: {
    claim: 'Podpora cestujících ze zpožděných nebo zrušených letů.',
    'contact-us': 'Kontaktujte nás od pondělí&nbsp;do pátku v hodinách:<br>',
    'weekdays-hours': '9:00 - 20:00',
    'on-weekends': 'v sobotu zavřeno:',
    'saturday-hours': '10:00 – 18:00',
    'contact-number-href': '+420234261919',
    'contact-number': '+420 234 26 19 19',
    'contact-email': 'info@delayfix.com',
    follow: 'Vyhledejte nás a předložte svůj dotaz:',
    compensation: 'Ověřit možnost kompenzace',
    rights: 'Vaše práva',
    blog: 'Blog',
    faq: 'FAQ',
    contact: 'Kontakt',
    about: 'O nás',
    company: {
      name: 'DelayFix S.A.',
      'address-1': 'Aleje Ujazdowskie 22/5',
      'address-2': '00-478 Warszawa',
      registration:
        'Okresní soud hlavního města Varšavy ve Varšavě, XII Obchodní oddělení Národního soudního rejstříku, KRS 742480',
      nip: 'NIP 5213681825',
      'capital-1': 'Výše základního kapitálu:',
      'capital-2': '155 820,00 PLN'
    }
  },
  'check-compensation': 'Ověřit možnost kompenzace',
  gdpr: 'GDPR',
  'passenger-rights': 'Práva cestujících',
  terms: 'Pravidla',
  blog: 'Blog',
  contact: 'Kontakt',
  'add-intermediate': 'Řidejte transferové letiště',
  'intermediate-airport': 'Transferové letiště',
  'intermediate-airports': 'Transferové letiště',
  'entitled-amount': 'Právo na částku ve výši',
  'was-it-with-intermediate': 'Byl tento spoj s přestupem?',
  'add-more-data-to-calculate': 'Zadat více dat pro výpočet',
  'preferred-contact-language': 'Preferovaný jazyk kontaktu',
  polish: 'polština',
  english: 'angličtina',
  russian: 'ruština',
  czech: 'čeština',
  'error-invalid-phone': 'Neplatné telefonní číslo',
  'passenger-has-been-added':
    'Do letu č. {flight} byl přidán cestující (telefonní č. {phone})',
  'flight-has-been-added': 'Byl přidán let č. {flight}',
  compensation: 'Odškodné',
  'your-compensation': 'Vaše odškodnění',
  'remove-airport': 'Vyjměte letiště'
}
